import p1 from "./service1.svg";
import p2 from "./service2.svg";
import p3 from "./service3.svg";

const ServicesData = [
  {
    id: 1,
    title: "Service One",
    text: " Lorem ipsum dolor sit amet consectetur, adipisicing elit.Maiores voluptatum corporis",
    imgPath: p1,
  },
  {
    id: 2,
    title: "Service Two",
    text: " Lorem ipsum dolor sit amet consectetur, adipisicing elit.Maiores voluptatum corporis",
    imgPath: p2,
  },
  {
    id: 3,
    title: "Service Three",
    text: " Lorem ipsum dolor sit amet consectetur, adipisicing elit.Maiores voluptatum corporis",
    imgPath: p3,
  },
];

export default ServicesData;
